import type { ReporterSummaryResponseDto } from 'app/API';

import { Content } from './ReporterSummaryPreviewModal/styles/Content';
import { EmptyState } from './ReporterSummaryPreviewModal/styles/EmptyState';
import { Footer } from './ReporterSummaryPreviewModal/styles/Footer';
import { Header } from './ReporterSummaryPreviewModal/styles/Header';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { JobName } from './ReporterSummaryPreviewModal/styles/JobName';
import { Meta } from './ReporterSummaryPreviewModal/styles/Meta';
import { ModalWrapper } from './ReporterSummaryPreviewModal/styles/ModalWrapper';
import { Speaker } from './ReporterSummaryPreviewModal/styles/Speaker';
import { Subtitle } from './ReporterSummaryPreviewModal/styles/Subtitle';
import { SummaryItem } from './ReporterSummaryPreviewModal/styles/SummaryItem';
import { SummaryLine } from './ReporterSummaryPreviewModal/styles/SummaryLine';
import { SummaryList } from './ReporterSummaryPreviewModal/styles/SummaryList';
import { TitleBlock } from './ReporterSummaryPreviewModal/styles/TitleBlock';

type Props = {
  jobName: string;
  reporterSummary: ReporterSummaryResponseDto | null;
  onCancel: () => void;
};

export const ReporterSummaryPreviewModal = ({ jobName, reporterSummary, onCancel }: Props) => {
  const summaryLines = reporterSummary?.summaryLines ?? [];

  return (
    <ModalWrapper>
      <Header>
        <TitleBlock>
          <Subtitle>Reporter summary preview</Subtitle>
          <JobName>{jobName}</JobName>
        </TitleBlock>
        <OutlinedButton className="min-w-[110px] w-auto shrink-0" type="button" onClick={onCancel}>
          Close
        </OutlinedButton>
      </Header>

      <Content>
        {summaryLines.length ? (
          <SummaryList>
            {summaryLines.map((line, index) => {
              const rawTurnIndex = typeof line.turnIndex === 'number' ? line.turnIndex : null;
              const normalizedTurn = rawTurnIndex !== null ? rawTurnIndex + 1 : index + 1;
              const itemKey = rawTurnIndex !== null ? `turn-${rawTurnIndex}` : `row-${index}`;
              return (
                <SummaryItem key={itemKey}>
                  <Speaker>{line.speaker?.trim() || 'Speaker'}</Speaker>
                  <SummaryLine>{line.summaryLine}</SummaryLine>
                  <Meta>Turn #{normalizedTurn}</Meta>
                </SummaryItem>
              );
            })}
          </SummaryList>
        ) : (
          <EmptyState>No reporter summary data returned.</EmptyState>
        )}
      </Content>

      <Footer>
        <OutlinedButton className="min-w-[110px] w-auto shrink-0" type="button" onClick={onCancel}>
          Done
        </OutlinedButton>
      </Footer>
    </ModalWrapper>
  );
};
